import { defineStore } from 'pinia'
import axios from 'axios'

interface User {
  id: number
  name: string
  surname: string
  email: string
  gender: number
  height: number
  email_verified_at: string | null
  created_at: string
  updated_at: string
}

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      profile: null as User | null,
      token:
        localStorage.getItem('token') != null && localStorage.getItem('token') != ''
          ? localStorage.getItem('token')
          : null,
    }
  },

  actions: {
    async fetchUser() {
      return axios.get<User>('/user').then((response) => {
        this.profile = response.data
      })
    },
    async signUp(payload: object) {
      interface RegisterResponse {
        access_token: string
        token_type: string
      }

      return axios.post<RegisterResponse>('/register', payload)
    },
    async login(payload: object) {
      interface LoginResponse {
        access_token: string
        token_type: string
      }

      return axios.post<LoginResponse>('/login', payload)
    },
    async updateUser(payload: object) {
      return axios.post('/user', payload).then((response) => {
        this.profile = response.data?.user
      })
    },
    async measurements() {
      return axios.get('/measurements')
    },
    async addMeasurement(payload: FormData) {
      return axios.post('/measurements', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`,
        },
      })
    },
    async updateMeasurement(id: number, payload: FormData) {
      return axios.post('/measurements/' + id, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.token}`,
        },
      })
    },
    async getMeasurement(id: number) {
      return axios.get('/measurements/' + id)
    },
    async deleteMeasurement(id: number) {
      return axios.post('/delete-measurement/' + id)
    },
    async dashboard() {
      return axios.get('/dashboard')
    },
    async myEvolution() {
      return axios.get('/my-evolution')
    },
    setToken(token: string) {
      this.token = token
    },
    logout() {
      localStorage.removeItem('token')
      this.profile = null
      this.token = null
    },
  },
})
